import React from 'react';
/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  useLdrz,
  useMsgz,
  useCfmz,
  a,
  ls,
  gs,
  f,
//  BarC,
  BoxC,
  BtnC,
  GridC,
  HtyC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as HtyC from "./_ccmHtyC";
import * as _cm from './_cm';
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import { useMsgz } from "./_csMdlMsg";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as icm from './icm';
import * as ict from './ict';

import * as ihdI18 from './ihdI18';

import * as IccAby from './icvI1z___TzAby';

import * as icvI10___Tz from './icvI10___Tz';
import * as icvI17___Tz from './icvI17___Tz';

//import * as icvI17___Mz from './icvI17___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

import * as icvI1zS11Co3a from './icvI1zS11Co3a';
import * as icvI1zS11Co3b from './icvI1zS11Co3b';
import * as icvI1zS11Co3c from './icvI1zS11Co3c';
import * as icvI1zS11Co3d from './icvI1zS11Co3d';
import * as icvI1zS11Co3e from './icvI1zS11Co3e';
import * as icvI1zS11Co3f from './icvI1zS11Co3f';
import * as icvI1zS11Co3g from './icvI1zS11Co3g';

let $i1zz = icvI1z___Mz.ilzI1zz();
//let $i17rs = [] as _ht.ls;
let $i18rz = {} as _ht.dz;

export const N = (pz: {
  sPz: _ht.dz,
  pagez: _ht.dz,
}) => {

  const _frcUdt = ls.frcUdt();
  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sLdrz = useLdrz();
  const _sMsgz = useMsgz();
  const _sCfmz = useCfmz();

  React.useEffect(() => {
    _cmFTH.loadAllAsync({
      frcUdt: _frcUdt,
      ldrz: _sLdrz,
/*
      bfrAsync: () => [
        icvI17___Mz.loadI17rLsAsync({
          _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
        })
        .then((_ls: _ht.ls) => {
//hf.l(`icvI1zS11Co3 71: here`);
          $i17rs = _ls;
        })
      ],
*/
      atrAsync: () => [
        icvI1z___Mz.loadI1zrDzAsync({
          i1zr_fst: pz.sPz.crt.i1zr_fst,
          vsn: pz.sPz.crt.vsn,
        })
        .then( async (_dz: ict.i1zz) => {
//hf.l(`icvI1zS11Co3 93a: ${pz.sPz.crt.i1zr_fst}, ${pz.sPz.crt.vsn}`);
          $i1zz = _dz;
//hf.l(`icvI1zS11Co3 93b: ${hf.s($i1zz)}`);
          icm.udtI1z3z({
            i1zz: $i1zz,
            i17rs: pz.pagez.i17rs,
          });
          if (_hm.f($i1zz.i18rz)) {
//hf.l(`icvI1zS11Co3 88: here`);
            await icm.setStgzAsync({
              _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
              i18r_fst: $i1zz.i18rz._fst,
            })

            $i18rz = await _cmFTH.loadDzAsync(ihdI18.grtPzForLoadI18rPs(_cm.grtUz(), { // 団体
              //_31r_fst: _gUserz.crt._31rz?._fst ?? -1,
              i18r_fst: $i1zz.i18rz._fst, // 施設またぎがあるため _31r_fst を指定しない
            }));
//_hm.l(`icvI1zS11Co3 124a: ${_gUserz.crt._31rz?._fst}`);
//_hm.l(`icvI1zS11Co3 124b: ${$i1zz.i18rz._fst}`);
//_hm.l(`icvI1zS11Co3 124c: ${_hm.s($i18rz)}`);

//hf.l(`icvI1zS11Co3 93: here`);
          }
        })
      ],
    })
  }, [
    _gUserz.crt._31rz?._fst,
    pz.sPz.crt.phs,
    pz.sPz.crt.i1zr_fst,
    pz.sPz.crt.vsn,
  ]);

//hf.l(`icvI1zS11Co3 105: ${_gUserz.crt._31rz?._fst}`);
//hf.l(`icvI1zS11Co3 105: ${hf.s(pz.sPz.crt)}`);
//hf.l(`icvI1zS11Co3 124a: ${pz.sPz.crt.phs}`);
//hf.l(`icvI1zS11Co3 124b: ${$i1zz.i1zrz.i1zrs1100i}`);
//hf.l(`icvI1zS11Co3 124c: ${$i1zz.i1zrz.i1zrs1200i}`);
//hf.l(`icvI1zS11Co3 124d: ${$i1zz.i1zrz.i1zr_31r1f}, ${_gUserz.crt._31rz._fst}`);
//hf.l(`icvI1zS11Co3 124b: ${hf.s($i1zz.i18rz)}`);

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

                
        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a('mb/2'),
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [],
                },
                {
                  oClds: [],
                },
                {
                  oClds: [
                    cr.c(HtyC.N, {
                      key: -10,
                      sPz: pz.sPz,
                      cz: {
                        elm: 'i1zr',
                        _fst: pz.sPz.crt.i1zr_fst,
                      }
                    })

                  ]
                }
              ]
            }
          ]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(SrlC.V, {
              key: -10,
              abtType: 'cttCmnz',
              oClds: [

                _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                cr.c(TextC.N, {
                  key: -20,
                  abtType: 'rmkCmnz',
                  boxStlz: a(`dw/f fd/rsc mb/1`),
                  textz: {
                    pfx: '※：必須',
                  }
                })
                : null,

                cr.c(LblC.N, {
                  key: -30,
                  abtType: 'bandLeftStfz',
                  lblCz: {
                    textz: {
                      pfx: '団体情報',
                      stlz: a('ts/l'),
                    }
                  },
                  cttCz: {
                    boxStlz: a('ph/2'),
                    oClds: [

                      cr.c(icvI1zS11Co3a.N, {
                        key: -10,
                        sPz: pz.sPz,
                        cz: {
                          i1zz: $i1zz,
                        }
                      })

                    ]
                  }
                }),

                cr.c(LblC.N, {
                  key: -40,
                  abtType: 'bandLeftStfz',
                  lblCz: {
                    textz: {
                      pfx: '予約内容',
                      stlz: a('ts/l'),
                    }
                  },
                  cttCz: {
                    boxStlz: a('ph/2'),
                    oClds: [

                      cr.c(icvI1zS11Co3b.N, {
                        key: -10,
                        boxStlz: a('mb/2'),
                        sPz: pz.sPz,
                        cz: {
                          i1zz: $i1zz,
                        }
                      }),

                      cr.c(icvI10___Tz.T, {
                        key: -20,
                        boxStlz: a('mb/2'),
                        sPz: pz.sPz,
                        frcUdt: _frcUdt,
                        cz: {
                          bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) && $i1zz.i1zrz.i1zrs1100i != 90,
                          i1zz: $i1zz,
                          _31r_fst: _gUserz.crt._31rz._fst,
                        },
                      }),

                      cr.c(BoxC.N, {
                        key: -25,
                        boxStlz: a('dw/f mb/2 mt/1 p/1 sc/lm1'),
                        oClds: [
                          cr.c(IccAby.V3, {
                            key: -10,
                            sPz: pz.sPz,
                            frcUdt: _frcUdt,
                            cz: {
                              bEdit: false,
                              bNext: false,
                              date: $i1zz.i1zrz.i1zrd3100s,
                              i10r_fsts: _hm.grtLs(
                                $i1zz.i1z1s.filter((_dz: _ht.dz) => _dz._dlt != 1),
                                `i1z1i10r1f`
                              ),
                              i1zz: $i1zz,
                              _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
                            },
                          }),
                        ]
                      }),

                      pz.sPz.crt.ctt == 'r' ?
                      cr.c(icvI1zS11Co3c.N, { // 減免情報
                        key: -30,
                        sPz: pz.sPz,
                        frcUdt: _frcUdt,
                        cz: {
                          i1zz: $i1zz,
                          i17rs: pz.pagez.i17rs,
                        }
                      })
                      : null,

                      cr.c(BoxC.N, {
                        key: -40,
//                        boxStlz: a(`bc/gn7 bwb/1 dw/f fd/rbs pb/1 sc/gn1`),
                        boxStlz: a(`dw/f fd/rbs pt/1 pb/1 sc/gn1`),
                        oClds: [

                          _gUserz.crt.i19rz.i19ra2210i == 1 ?
                          cr.c(icvI17___Tz.T, { // 備品・駐車場
                            key: -20,
                            sPz: pz.sPz,
                            boxStlz: a(`dw/60`),
                            cz: {
                              bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              i1zz: $i1zz,
                              _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
                              clr: pz.sPz.crt.dffz.clr,
                            }
                          })
                          : undefined,

                          pz.sPz.crt.ctt == 'r' ?
                          cr.c(TextC.N, {
                            key: -10,
                            //boxStlz: a(`f/1 pr/2`),
                            boxStlz: a(`dw/60 p/1`),
                            textz: {
                              //pfx: '▼これ以下の料金は横浜市のシステムへは、連携していません。',
                              pfx: 
                              _gUserz.crt.i19rz.i19ra2210i == 1 ?
                                '◆備品・駐車場／その他支払内容の金額は、横浜市システム連携に含みません。'
                              : 'その他支払内容の金額は、横浜市システム連携に含みません。',
                            }
                          })
                          : null,

                        ]
                      }),

                      pz.sPz.crt.ctt == 'r' ?
                      cr.c(icvI1zS11Co3d.N, {
                        key: -50,
                        sPz: pz.sPz,
                        cz: {
                          i1zz: $i1zz,
                          i17rs: pz.pagez.i17rs,
                        }
                      })
                      : null,

                      cr.c(icvI1zS11Co3e.N, {
                        key: -60,
                        sPz: pz.sPz,
                        cz: {
                          i1zz: $i1zz,
                          i17rs: pz.pagez.i17rs,
                        }
                      }),

                    ]
                  }
                }),

                _gStgz.crt.S01999232 == 1 ?
                cr.c(LblC.N, {
                  key: -45,
                  abtType: 'bandLeftStfz',
                  lblCz: {
                    textz: {
                      pfx: '団体からの伝達事項',
                    }
                  },
                  cttCz: {
                    boxStlz: a('dw/f ph/2'),
                    oClds: [
                      cr.c(IptC.S, {
                        key: -10,
                        cz: {
                          bEdit: _hm.i(pz.sPz.crt.phs, ['crt', 'udt']),
                          iptType: 'text',
                          vle: $i1zz?.i1zrz.i1zra8100s,
                          onChg: ( _s: _ht.s ) => {
                            $i1zz.i1zrz.i1zra8100s = _s;
                          }
                        }
                      })
                    ]
                  }
                })
                : undefined,

                cr.c(LblC.N, {
                  key: -50,
                  abtType: 'bandLeftStfz',
                  lblCz: {
                    textz: {
                      pfx: '内部メモ',
                    }
                  },
                  cttCz: {
                    boxStlz: a('ph/2'),
                    oClds: [
                      cr.c(icvI1zS11Co3f.N, {
                        key: -10,
                        sPz: pz.sPz,
                        cz: {
                          i1zz: $i1zz,
                        }
                      })
                    ]
                  }
                }),

                pz.sPz.crt.ctt == 'r' ?
                cr.c(LblC.N, {
                  key: -60,
                  abtType: 'bandLeftStfz',
                  lblCz: {
                    textz: {
                      pfx: '利用人数',
                    }
                  },
                  cttCz: {
                    boxStlz: a('ph/2'),
                    oClds: [
                      cr.c(icvI1zS11Co3g.N, {
                        key: -10,
                        sPz: pz.sPz,
                        cz: {
//                          i1z4z: $i1z4z,
                          ... $i1zz,
                        }
                      })
                    ]
                  }
                })
                : null,
              ],
            }),

            cr.c(GridC.N, {
              key: -20,
              abtType: 'barBtnViewCmnz',
              lineCs: [
                {
                  cellCs: 
                  pz.sPz.crt.vsn > 0 ?
                  [
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: '最新の内容に戻る',
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                vsn: -1,
                              })
                            }
                          },
                        })
                      ]
                    }
                  ]
                  :
                  [
                    pz.sPz.crt.phs == 'crt' ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -110,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
      //                        pfx: `${pz.sPz.crt.dffz.tgt}一覧画面に戻る`,
                              pfx: `団体の選択画面に戻る`,
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [2],
                                phs: 'crt',
                              })
                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'crt' ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -120,
                          abtType: 'nextCmnz',
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}内容を登録`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzAddAsync1({
                                role: 's',
                                ctt: pz.sPz.crt.ctt,
                                _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                chkStep: 3,
                                sMsgz: _sMsgz,
                                sLdrz: _sLdrz,
                                sCfmz: _sCfmz,
                                atrAsync: (_dz: _ht.dz) => {
                                  pz.sPz.set({
                                    steps: 
                                      pz.sPz.crt.ctt == 'r' ?
                                        [4]
                                      : pz.sPz.crt.ctt == 'e' ?
                                        [0]
                                      : [0],
                                    phs: 'dpy'
                                  })
                                },
                                phs: pz.sPz.crt.phs,
                              })

                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'dpy' ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -210,
                          abtType: 'backCmnz',
                          boxStlz: 
                            pz.sPz.crt.ctt == 'e' ?
                              a('dw/29')
                            : a('dw/22'),
                          lblCz: {
                            textz: {
                              pfx: `${pz.sPz.crt.dffz.tgt}一覧画面に戻る`,
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [0],
                                phs: 'dpy',
                              })
                            }
                          },
                        }),
                      ]
                    }
                    : null,
/*
                    pz.sPz.crt.phs == 'dpy' && 
                    $i1zz.i1zrz.i1zrs1100i != 20 && 
                    $i1zz.i1zrz.i1zrs1200i != 20 &&
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
*/
                    pz.sPz.crt.phs == 'dpy' && 
                    (
                      (pz.sPz.crt.ctt == 'r' && $i1zz.i1zrz.i1zrs1100i != 20) || 
                      (pz.sPz.crt.ctt == 'e' && $i1zz.i1zrz.i1zrs1200i != 20)
                    ) &&
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -220,
                          abtType: 'nextCmnz',
                          boxStlz: 
                            pz.sPz.crt.ctt == 'e' ?
                              a('dw/29')
                            : a('dw/22'),
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}を変更`,
      //                        ptyz: a('tn/2'),
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                phs: 'udt',
                              });
                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'dpy' && 
                    pz.sPz.crt.ctt == 'r' && 
                    $i1zz.i1zrz.i1zrs1100i != 20 &&
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -220,
                          abtType: 'nextCmnz',
                          boxStlz: a('dw/22'),
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}を印刷`,
      //                        ptyz: a('tn/2'),
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [4]
                              })
                            }
                          },
                        }),
                      ]
                    }
                    : null,
/*
                    pz.sPz.crt.phs == 'dpy' && 
                    ($i1zz.i1zrz.i1zrs1100i != 20) && 
                    ($i1zz.i1zrz.i1zrs1200i != 20) &&
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
*/
                    pz.sPz.crt.phs == 'dpy' && 
                    (
                      (pz.sPz.crt.ctt == 'r' && $i1zz.i1zrz.i1zrs1100i != 20) || 
                      (pz.sPz.crt.ctt == 'e' && $i1zz.i1zrz.i1zrs1200i != 20)
                    ) &&
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -230,
                          abtType: 'backCmnz',
                          boxStlz: 
                            pz.sPz.crt.ctt == 'e' ?
                              a('dw/29')
                            : a('dw/22'),
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}をキャンセル`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzCclAsync1({
                                role: 's',
                                ctt: pz.sPz.crt.ctt,
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
                                sCfmz: _sCfmz,
                                sLdrz: _sLdrz,
                                atrAsync: () => {
                                  pz.sPz.set({
                                    steps: [0],
                                    //bBack: true,
                                  })
                                }
                              })
                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'dpy' && 
                    $i1zz.i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -240,
                          abtType: 'backCmnz',
                          boxStlz: 
                            pz.sPz.crt.ctt == 'e' ?
                              a('dw/29')
                            : a('dw/22'),
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}を削除`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzDltAsync1({
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                ctt: pz.sPz.crt.ctt,                                
                                sCfmz: _sCfmz,
                                sLdrz: _sLdrz,
                                atrAsync: () => {
                                  pz.sPz.set({
                                    //bBack: true,
                                    steps: [0]
                                  })
                                }
                              })

                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'udt' ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -310,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: `変更を止める`,
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                phs: 'dpy',
                              })
                            }
                          },
                        }),
                      ]
                    }
                    : null,
                    pz.sPz.crt.phs == 'udt' ?
                    {
                      oClds: [
                        cr.c(BtnC.N, {
                          key: -320,
                          abtType: 'nextCmnz',
                          lblCz: {
                            textz: {
                              pfx: `この${pz.sPz.crt.dffz.tgt}内容に変更`,
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              icm.saveI1zzAddAsync1({
                                role: 's',
                                ctt: pz.sPz.crt.ctt,
                                _31r_fst: _gUserz.crt._31rz?._fst ?? -1,
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: $i18rz,
                                hdys: pz.pagez.hdys,
                                chkStep: 3,
                                sMsgz: _sMsgz,
                                sLdrz: _sLdrz,
                                sCfmz: _sCfmz,
                                atrAsync: (_dz: _ht.dz) => {
                                  pz.sPz.set({
                                    steps: 
                                      pz.sPz.crt.ctt == 'r' ?
                                        [4]
                                      : pz.sPz.crt.ctt == 'e' ?
                                        [0]
                                      : [0],
                                    phs: 'dpy'
                                  })
                                },
                                phs: pz.sPz.crt.phs,
                              })

                            }
                          },
                        })
                      ]
                    }
                    : null,
                  ]
                }
              ]
            }),

          ]
        })
      ]
    })
  );
};
